<template>
    <div>
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ item?.title }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active" aria-current="page">{{ item?.title }}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="fresh-vegetable-section section-lg-space">
            <div class="container-fluid-lg">
                <div class="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">


                    <div class="col-12">
                        <div class="fresh-contain p-center-left">
                            <div class="fresh-inner">
                                <div class="fresh-content">
                                    <div v-html="item?.content"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    data() {
        return {
            item: []
        }
    },
    created() {

        const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });

        axios.get(`pages/${this.$route.params.id}`, {}).then(response => {

            this.item = response.data.data;

            toast.dismiss(id);
        }, response => {
            toast.dismiss(id);
        });
    },
}
</script>
